import { atom } from 'jotai'

export const shiftKeyIsPressedAtom = atom(false)
